import { render } from "./LaunchSponsor.vue?vue&type=template&id=71aae8c0&scoped=true"
import script from "./LaunchSponsor.vue?vue&type=script&lang=js"
export * from "./LaunchSponsor.vue?vue&type=script&lang=js"

import "./LaunchSponsor.vue?vue&type=style&index=0&id=71aae8c0&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71aae8c0"]])

export default __exports__